// Query params for fetching the full platform list to populate a selector
// (CVT Quoting Platform dropdown, benefits-set privileged_platforms field).
//
// The /platforms index is paginated (Kaminari default 25/page), so a selector
// that assumes one page == the whole list silently drops platforms once there
// are more than 25 — PD-28969, where the oldest platform (Rippling) fell off
// the default page. Requesting a page large enough to hold every platform
// returns the full list, and sort=name returns it alphabetically for display.
export const ALL_PLATFORMS_PER_PAGE = 1000

export const platformSelectParams = { per_page: ALL_PLATFORMS_PER_PAGE, sort: 'name' }
